<h2>{{ dialogData.mode === 'widget' ? 'Edit property URL' : 'Edit property URL slug' }}</h2>

<div fxLayout="column" fxLayoutGap="12px">
  <span *ngIf="dialogData.mode !== 'widget'" style="padding-bottom: 24px">
    The slug is the last part of the URL that uniquely identifies a property. If you edit the property's slug, it will
    change the property's URL on all of your Direct sites, and any existing links that use a former property slug will
    no longer work.
  </span>

  <span *ngIf="dialogData.mode === 'widget'" style="padding-bottom: 24px">
    What is the URL for this property on your custom site?
  </span>

  <mat-form-field class="fw">
    <mat-label>Property {{ dialogData.mode === 'widget' ? 'URL' : 'Slug' }}</mat-label>
    <input
      matInput
      [placeholder]="dialogData.mode === 'widget' ? 'https://example.com/properties/my-property' : 'New property slug'"
      [ngModel]="dialogData.slug"
      (ngModelChange)="newSlug = $event" />
  </mat-form-field>

  <div fxLayoutAlign="end center" fxLayoutGap="12px">
    <sbnb-button type="secondary" (clicked)="dialogRef.close(false)">Cancel</sbnb-button>
    <sbnb-button [loading]="saving" (clicked)="dialogData.mode === 'widget' ? updateCustomSiteUrl() : updateSlug()">
      Update
    </sbnb-button>
  </div>
</div>
